import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import { useToday } from '../hooks';

export const DayContext = createContext(null);

DayContext.displayName = 'DayContext';

export default function DayProvider({ children }) {
  const today = useToday();

  return (
    <DayContext.Provider value={today}>
      {children}
    </DayContext.Provider>
  );
}

DayProvider.propTypes = {
  children: PropTypes.node,
};
